import { createReducer } from 'reduxsauce'

import importer from 'common/importer'

const { INITIAL_STATE } = importer('Stores/Payments/InitialState', null)
const { PaymentsTypes } = importer('Stores/Payments/Actions', null)

const getPaymentsCouponProgressLoading = state => ({
  ...state,
  getPaymentsCouponProgressLoading: true,
  getPaymentsCouponProgressSuccess: null,
  getPaymentsCouponProgressFailure: null
})
const getPaymentsCouponProgressSuccess = (state, { res }) => ({
  ...state,
  getPaymentsCouponProgressLoading: false,
  getPaymentsCouponProgressSuccess: res,
  getPaymentsCouponProgressFailure: null
})
const getPaymentsCouponProgressFailure = (state, { error }) => ({
  ...state,
  getPaymentsCouponProgressLoading: false,
  getPaymentsCouponProgressSuccess: null,
  getPaymentsCouponProgressFailure: error
})

const applyPaymentPromoCodeLoading = state => ({
  ...state,
  applyPaymentPromoCodeLoading: true,
  applyPaymentPromoCodeSuccess: null,
  applyPaymentPromoCodeFailure: null
})
const applyPaymentPromoCodeSuccess = (state, { res }) => ({
  ...state,
  applyPaymentPromoCodeLoading: false,
  applyPaymentPromoCodeSuccess: res,
  applyPaymentPromoCodeFailure: null
})
const applyPaymentPromoCodeFailure = (state, { error }) => ({
  ...state,
  applyPaymentPromoCodeLoading: false,
  applyPaymentPromoCodeSuccess: null,
  applyPaymentPromoCodeFailure: error
})

const getPaymentHistoryLoading = state => ({
  ...state,
  getPaymentHistoryLoading: true,
  getPaymentHistorySuccess: null,
  getPaymentHistoryFailure: null
})
const getPaymentHistorySuccess = (state, { res }) => ({
  ...state,
  getPaymentHistoryLoading: false,
  getPaymentHistorySuccess: res,
  getPaymentHistoryFailure: null
})
const getPaymentHistoryFailure = (state, { error }) => ({
  ...state,
  getPaymentHistoryLoading: false,
  getPaymentHistorySuccess: null,
  getPaymentHistoryFailure: error
})

const cleanPaymentState = state => ({
  ...state,
  applyPaymentPromoCodeSuccess: null,
  getPaymentsCouponProgressSuccess: null
})

export const reducer = createReducer(INITIAL_STATE, {
  [PaymentsTypes.GET_PAYMENTS_COUPON_PROGRESS_LOADING]: getPaymentsCouponProgressLoading,
  [PaymentsTypes.GET_PAYMENTS_COUPON_PROGRESS_SUCCESS]: getPaymentsCouponProgressSuccess,
  [PaymentsTypes.GET_PAYMENTS_COUPON_PROGRESS_FAILURE]: getPaymentsCouponProgressFailure,

  [PaymentsTypes.APPLY_PAYMENT_PROMO_CODE_LOADING]: applyPaymentPromoCodeLoading,
  [PaymentsTypes.APPLY_PAYMENT_PROMO_CODE_SUCCESS]: applyPaymentPromoCodeSuccess,
  [PaymentsTypes.APPLY_PAYMENT_PROMO_CODE_FAILURE]: applyPaymentPromoCodeFailure,

  [PaymentsTypes.GET_PAYMENT_HISTORY_LOADING]: getPaymentHistoryLoading,
  [PaymentsTypes.GET_PAYMENT_HISTORY_SUCCESS]: getPaymentHistorySuccess,
  [PaymentsTypes.GET_PAYMENT_HISTORY_FAILURE]: getPaymentHistoryFailure,

  [PaymentsTypes.CLEAN_PAYMENT_STATE]: cleanPaymentState
})
